export default function Legal() {
  return (
    <div className="page" style={{ padding: '20px', lineHeight: '1.6' }}>
      <h1>Mentions Légales</h1>

      <section>
        <h2>1. Édition du site</h2>
        <p>
          Le site <strong>GamePulse HQ</strong> est édité par <strong>Mamadou Ly</strong>.
          <br />
          Contact : <strong>lmamadou211@gmail.com</strong>.
        </p>
      </section>

      <section>
        <h2>2. Hébergement</h2>
        <p>
          Ce site est hébergé par <strong>Google Firebase Hosting</strong>.
          <br />
          Siège social : Google LLC, 1600 Amphitheatre Parkway, Mountain View, CA 94043, États-Unis.
        </p>
      </section>

      <section>
        <h2>3. Affiliation et Partenariats</h2>
        <p>
          GamePulse HQ participe à plusieurs programmes d'affiliation, notamment <strong>Instant Gaming</strong> et le <strong>Programme Partenaires d'Amazon EU</strong>.
        </p>
        <blockquote>
          <p>
            <em>« En tant que Partenaire Amazon, je réalise un bénéfice sur les achats remplis par les conditions requises. »</em>
          </p>
        </blockquote>
        <p>
          Si vous effectuez un achat via ces liens, une commission peut nous être versée sans aucun surcoût pour vous. Cela permet de soutenir le développement du site.
        </p>
      </section>

      <section>
        <h2>4. Propriété intellectuelle</h2>
        <p>
          Les contenus originaux sont la propriété de l'éditeur. Les noms de jeux, logos et visuels (comme ceux de GTA VI ou Elden Ring) appartiennent à leurs éditeurs respectifs.
        </p>
      </section>
    </div>
  );
}